import { z } from 'zod';
import { ferriesSchema } from './ferries.schema';
import { restrictionZonesSchema } from './restriction-zones.schema';
import { routingTypeSchema } from './routing-type.schema';
import { tollRoadTypeSchema } from './toll-road-type.schema';
import { sideOfStreetAdherenceLevelSchema } from './side-of-street-adherence-level.schema';

export const routingOptionsSchema = z.object({
  ferries: ferriesSchema,
  restrictionZones: restrictionZonesSchema.optional(),
  useStateAndNationalNetwork: z.boolean().optional().nullable(),
  routeType: routingTypeSchema,
  tollRoads: tollRoadTypeSchema,
  useOpenBorders: z.boolean().optional().nullable(),
  elevationLimit: z.number().optional(),
  sideOfStreetAdherenceLevel: sideOfStreetAdherenceLevelSchema,
});
